// update FAQ query accordion title with post title text
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.faqs-query .wp-block-kadence-pane').forEach(pane => {
    const title = pane.querySelector('.faqs-query .kt-blocks-accordion-title');
    const postTitle = pane.querySelector('.faqs-query .kt-accordion-panel-inner .wp-block-post-title');

    if (title && postTitle) {
      title.textContent = postTitle.textContent.trim();
      postTitle.remove();
    }
  });
});
